import { apiFetch } from '@lib/api/apiClient';

export async function registerPlan(formData) {
    const res = await apiFetch('/plan/register', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });

    if (!res.ok) {
        throw new Error('플랜 정보 저장에 실패하였습니다.');
    }
    return (await res.json()).data;
}

export async function modifyPlan(formData) {
    const res = await apiFetch('/plan/modify', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });
    if (!res.ok) {
        throw new Error('플랜 정보 수정에 실패하였습니다.');
    }
    return (await res.json()).data;
}

export async function reorderPlan(formData) {
    const res = await apiFetch('/plan/reorder', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });
    if (!res.ok) {
        throw new Error('플랜 정보 수정에 실패하였습니다.');
    }
    return (await res.json()).data;
}

/**
 * @param {any} searchParam
 */
export async function getPlan(searchParam) {
    const res = await apiFetch(`/plan/list`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(searchParam)
    });

    if (!res.ok) {
        throw new Error('플랜 목록을 불러오지 못했습니다.');
    }

    return (await res.json()).data;
}